import Strategy from "app/types/Strategy";
// Actions
import MixpanelActions from "app/features/mixpanel/MixpanelActions";
// Strategies
import {
  handleBillingInvoicesACHPaymentStrategy,
  handleBillingInvoicesBulkACHPaymentStrategy,
  handleBillingInvoicesBulkCardPaymentStrategy,
  handleBillingInvoicesBulkPDFExportStrategy,
  handleBillingInvoicesCardPaymentStrategy,
  handleBillingInvoicesCaseFilterStrategy,
  handleBillingInvoicesClientFilterStrategy,
  handleBillingInvoicesDateFilterStrategy,
  handleBillingInvoicesPDFExportStrategy,
  handleBillingInvoicesSearchFilterStrategy,
  handleBillingInvoicesSelectAllVisibleStrategy,
  handleBillingInvoicesStatusFilterStrategy,
  handleBillingInvoicesViewStrategy,
  handleCostExplorerBreakdownSwitchStrategy,
  handleCostExplorerCaseFilterStrategy,
  handleCostExplorerClientFilterStrategy,
  handleCostExplorerDateFilterStrategy,
  handleCostExplorerInvoiceClickStrategy,
  handleCostExplorerServiceFilterStrategy,
  handleCostExplorerShowAllInvoicesStrategy,
  handleCostExplorerSubscriptionFilterStrategy,
  handleCostExplorerViewStrategy,
  handleSubscriptionsViewStrategy,
  handleUsageReportViewStrategy
} from "../MixpanelStrategies/BillingAndSubscriptions.strategies";

const BillingAndSubscriptionsStrategyMap:Record<string, Strategy> = {
  [MixpanelActions.handleBillingInvoicesView.type]: handleBillingInvoicesViewStrategy,
  [MixpanelActions.handleSubscriptionsView.type]: handleSubscriptionsViewStrategy,
  [MixpanelActions.handleUsageReportView.type]: handleUsageReportViewStrategy,
  [MixpanelActions.handleCostExplorerView.type]: handleCostExplorerViewStrategy,

  [MixpanelActions.handleBillingInvoicesClientFilterClick.type]: handleBillingInvoicesClientFilterStrategy,
  [MixpanelActions.handleBillingInvoicesStatusFilterClick.type]: handleBillingInvoicesStatusFilterStrategy,
  [MixpanelActions.handleBillingInvoicesSearchFilterClick.type]: handleBillingInvoicesSearchFilterStrategy,
  [MixpanelActions.handleBillingInvoicesDateFilterClick.type]: handleBillingInvoicesDateFilterStrategy,
  [MixpanelActions.handleBillingInvoicesCaseFilterClick.type]: handleBillingInvoicesCaseFilterStrategy,
  [MixpanelActions.handleBillingInvoicesSelectAllVisibleClick.type]: handleBillingInvoicesSelectAllVisibleStrategy,
  [MixpanelActions.handleBillingInvoicesPDFExportClick.type]: handleBillingInvoicesPDFExportStrategy,
  [MixpanelActions.handleBillingInvoicesACHPaymentClick.type]: handleBillingInvoicesACHPaymentStrategy,
  [MixpanelActions.handleBillingInvoicesCardPaymentClick.type]: handleBillingInvoicesCardPaymentStrategy,
  [MixpanelActions.handleBillingInvoicesBulkPDFExportClick.type]: handleBillingInvoicesBulkPDFExportStrategy,
  [MixpanelActions.handleBillingInvoicesBulkACHPaymentClick.type]: handleBillingInvoicesBulkACHPaymentStrategy,
  [MixpanelActions.handleBillingInvoicesBulkCardPaymentClick.type]: handleBillingInvoicesBulkCardPaymentStrategy,

  [MixpanelActions.handleCostExplorerBreakdownSwitchClick.type]: handleCostExplorerBreakdownSwitchStrategy,
  [MixpanelActions.handleCostExplorerClientFilterClick.type]: handleCostExplorerClientFilterStrategy,
  [MixpanelActions.handleCostExplorerSubscriptionFilterClick.type]: handleCostExplorerSubscriptionFilterStrategy,
  [MixpanelActions.handleCostExplorerServiceFilterClick.type]: handleCostExplorerServiceFilterStrategy,
  [MixpanelActions.handleCostExplorerCaseFilterClick.type]: handleCostExplorerCaseFilterStrategy,
  [MixpanelActions.handleCostExplorerDateFilterClick.type]: handleCostExplorerDateFilterStrategy,
  [MixpanelActions.handleCostExplorerShowAllInvoicesClick.type]: handleCostExplorerShowAllInvoicesStrategy,
  [MixpanelActions.handleCostExplorerInvoiceClick.type]: handleCostExplorerInvoiceClickStrategy,
};

export default BillingAndSubscriptionsStrategyMap;
